import React from 'react'
import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { CampaignIDs } from 'types'
import { ExplorePageProps } from 'types/page'
import { explorePageInitialProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import MortgagePage from 'experiences/explore/simpleExplorePages/MortgagePage'
import { ContentfulProducts } from 'parameters/products'
import { DashboardLayout } from 'components/layout/LoggedIn/DashboardLayout'
import { ROUTES } from 'parameters'
import { ProductConstraint } from 'services/ContentfulService/constraints'

const Mortgage: NextPage<PagePropsWrapper<ExplorePageProps>> = ({
	metaTags,
	pageProps: { articles },
	parameters
}): JSX.Element => {
	const mode = parameters?.refinance === 'true' ? 'refinance' : 'normal'
	return (
		<StandardLayout metaTags={metaTags}>
			<DashboardLayout>
				<MortgagePage articles={articles} campaign={CampaignIDs.BBM} mode={mode} />
			</DashboardLayout>
		</StandardLayout>
	)
}

Mortgage.getInitialProps = explorePageInitialProps(ROUTES.MORTGAGE, ProductConstraint(ContentfulProducts.Mortgage))

export default Mortgage
